// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2FKgM","calendarButtons":"ClockData_calendarButtons__11-DB"};